export const emptyJobPermissions = { view: false, assign: false, advance: false };

export function canStoreJob(user, action = 'view') {
  return user?.role === 'store_manager'
    && user.jobPermissions?.view === true
    && user.jobPermissions?.[action] === true;
}